import { render, staticRenderFns } from "./App.vue?vue&type=template&id=79443f5c&scoped=true&"
import script from "./App.vue?vue&type=script&setup=true&lang=js&"
export * from "./App.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=79443f5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79443f5c",
  null
  
)

export default component.exports